export const ID_INTRO = Symbol('ID_INTRO');
export const ID_LOVE = Symbol('ID_LOVE');
export const ID_SOFT = Symbol('ID_SOFT');
export const ID_COOL = Symbol('ID_COOL');
export const ID_STRONG = Symbol('ID_STRONG');
export const ID_ENCOURAGE = Symbol('ID_ENCOURAGE');
export const ID_RESULTCARD = Symbol('ID_RESULTCARD');
